import { getMessages } from '../../../../../../../store/constants';

export const CARD_TAG_SAVE = getMessages().getText('common.save');
